module.exports = __webpack_public_path__ + "img/16.34255649.jpg";